import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=56e23c18"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TransferForm.vue?vue&type=style&index=1&id=56e23c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports